/**
 * PortfolioImpactCard — Portfolio exposure summary
 * MAESTRO:P1D · Relocated to predictions/ for MAESTRO:P8B
 *
 * Renders portfolio exposure: affected items count, total exposure value,
 * breakdown by severity (high/medium/low impact).
 */

export default function PortfolioImpactCard({ data }) {
  if (!data) return null;

  const { items_affected = 0, total_exposure = 0, breakdown } = data;

  return (
    <div
      className="bg-zinc-900 border-l-4 border-yellow-500 rounded-lg p-4 my-2"
      role="region"
      aria-label="Portfolio impact card"
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="text-yellow-500 font-bold text-xs uppercase tracking-wider">
          Portfolio Impact
        </span>
      </div>

      <div className="flex gap-6 mt-2">
        <div>
          <p className="text-zinc-500 text-xs">Items Affected</p>
          <p className="text-white font-mono text-lg">{items_affected}</p>
        </div>
        <div>
          <p className="text-zinc-500 text-xs">Total Exposure</p>
          <p className="text-white font-mono text-lg">
            ${parseFloat(total_exposure).toFixed(2)}
          </p>
        </div>
      </div>

      {breakdown && (
        <div className="flex gap-3 mt-3 text-xs">
          {breakdown.high > 0 && (
            <span className="bg-red-900/30 text-red-400 px-2 py-1 rounded">
              High: {breakdown.high}
            </span>
          )}
          {breakdown.medium > 0 && (
            <span className="bg-yellow-900/30 text-yellow-400 px-2 py-1 rounded">
              Medium: {breakdown.medium}
            </span>
          )}
          {breakdown.low > 0 && (
            <span className="bg-green-900/30 text-green-400 px-2 py-1 rounded">
              Low: {breakdown.low}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
